module.exports = __webpack_public_path__ + "img/logo.9ffb0ce4.jpg";